export default __webpack_public_path__ + "static/media/answers_open.3196af38.svg";